<template>
 <div class="accordionDiv">
    <button @click="toggleAccordion($event, id)" class="accordion">{{category}}</button>
    <div class="panel outer">
      <div class="questionDiv" v-for="(elem,index) in questions" v-bind:key="index">
        <button class="question" @click="toggleAccordion($event)">{{elem.question}}</button>
        <div class="panel" v-html="elem.answer">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { resolvePromise } from '../helpers/helpers';

export default {
  name: 'Accordion',
  data() {
    return {
      questions: []
    }
  },
  props: {
    id: {
      type: Number
    },
    onOpen: {
      type: Function
    },
    category:{
      type:String
    }
  },
  methods:{
    toggleAccordion(e, id = null){
      var _tog = el => {
        el.parentNode.classList.toggle("active");
        let panel = el.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          if(el.parentNode.classList.contains('questionDiv')){ 
            el.parentNode.parentNode.style.maxHeight = (el.parentNode.parentNode.scrollHeight + panel.scrollHeight) + "px"
          }
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      }
      const el = e.target;
      if(this.questions.length || !id) {
        _tog(el);
      } else {
        resolvePromise(this.onOpen(id), ({data}) => {
          this.questions = data.faQs;
          setTimeout(() => {
            _tog(el);
          }, 100);
        }, console.error, this);
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .accordionDiv{
    border-bottom: 1px solid #000;
    .button{
        // background: #E46C0A;
        width: 5%;
        color:#fff;
        float: left;
        padding: 15px 20px;
        cursor: pointer;
        &:hover,&:active{
            background: #d3b776;
        }
    }
  }
  .accordion {
      // background-color: #671176;
      font-weight: 700;
      font-size: 18px;
      color: #000;
      cursor: pointer;
      padding: 15px;
      width: 95%;
      text-align: left;
      border: none;
      outline: none;
      transition: 0.4s;
      &:hover,&:active{
          // background-color: #814e8e;
      }
    }  
  .panel {
    padding: 0 18px;
    background-color: white;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.2s ease-out;
    .questionDiv{
      margin-bottom: 10px;
      .question{
        font-weight: 700;
        cursor: pointer;
        border: none;
        outline: none;
        text-align: left;
      }
      .panel{
        margin-top: 10px;
      }
    }
  }
  .outer{
    height: auto;
  }
  @media screen and (max-width: 780px){
    .accordion { 
      width: 93%;
      height:60px;
    }
    .accordionDiv .button{
      height:60px;
      padding: 20px 12px;
    }
  }
  @media screen and (max-width: 430px){
    .accordion { 
      width: 88%;
    }
    .accordionDiv .button{
      width: 8%;
    }
  }
  @media screen and (max-width: 325px){

  }
</style>
